import moment from 'moment-timezone';
/** Pulls the hard-error code (e.g. CALENDAR_TOKEN_DISABLED) off a thrown error. */
export var extractErrorCode = function (error) {
    var _a, _b, _c;
    var code = (_c = (_b = (_a = error.graphQLErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.extensions) === null || _c === void 0 ? void 0 : _c.code;
    return typeof code === 'string' ? code : null;
};
/**
 * Derives partial-result metadata. Clamp is detected by comparing the requested
 * window against the one the server actually used; organizer-vs-invitee fetch
 * failures are split because they mean very different things to the user.
 */
export var buildPartialInfo = function (result, requestedWindow, organizerEmail) {
    var used = result.searchWindowUsed;
    var windowClamped = !!requestedWindow &&
        (!moment
            .parseZone(requestedWindow.from)
            .isSame(moment.parseZone(used.from)) ||
            !moment.parseZone(requestedWindow.to).isSame(moment.parseZone(used.to)));
    var lowerOrganizer = organizerEmail.toLowerCase();
    var organizerFetchFailed = result.fetchFailures.some(function (failure) { return failure.email.toLowerCase() === lowerOrganizer; });
    var failedInviteeEmails = result.fetchFailures
        .filter(function (failure) { return failure.email.toLowerCase() !== lowerOrganizer; })
        .map(function (failure) { return failure.email; });
    return {
        isPartial: result.partialResults,
        windowClamped: windowClamped,
        searchWindowUsed: { from: used.from, to: used.to },
        organizerFetchFailed: organizerFetchFailed,
        failedInviteeEmails: failedInviteeEmails,
    };
};
